import { useParams } from "react-router-dom";
import { useSeo } from "../hooks/useSeo";
import { LEGAL_PAGES } from "../lib/site";
import { Btn, Eyebrow } from "../components/Bits";

export default function Legal() {
  const { slug } = useParams();
  const page = LEGAL_PAGES[slug];

  useSeo({
    title: page ? `${page.title} | MAKO Mats` : "MAKO Mats",
    description: page?.body?.slice(0, 150),
  });

  if (!page)
    return (
      <div className="mx-auto max-w-[900px] px-6 py-32 lg:px-10">
        <h1 className="font-display text-3xl font-bold uppercase text-[#111111]">
          Page not found
        </h1>
        <div className="mt-10">
          <Btn to="/">Back to home</Btn>
        </div>
      </div>
    );

  return (
    <div data-testid={`legal-${slug}`} className="bg-white">
      <div className="mx-auto max-w-[900px] px-6 py-16 lg:px-10 lg:py-28">
        <Eyebrow>Legal</Eyebrow>
        <h1 className="mt-7 font-display text-3xl font-bold uppercase leading-tight tracking-tight text-[#111111] sm:text-4xl">
          {page.title}
        </h1>
        <div className="mt-10 border-l-2 border-[#0F4C81] pl-6">
          <p className="text-sm leading-relaxed text-[#3B3B3B] sm:text-base">{page.body}</p>
        </div>
        <p className="mt-12 border-t border-[#111111]/10 pt-8 text-xs text-[#7A7F85]">
          This page will be updated as the final wording is published. Contact MAKO if you need the
          current terms for a specific order.
        </p>
      </div>
    </div>
  );
}
